import { Injectable, effect, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  // Read initial preference directly from localStorage during initialization
  readonly isDarkMode = signal<boolean>(localStorage.getItem('theme') === 'dark');

  constructor() {
    // Angular Effect: Automatically runs whenever this.isDarkMode changes
    effect(() => {
      const themeValue = this.isDarkMode() ? 'dark' : 'light';
      localStorage.setItem('theme', themeValue);

      // 🚀 The Bootstrap Fix: Tell Bootstrap globally which theme is active
      document.documentElement.setAttribute('data-bs-theme', themeValue);

      // Clean cleanup of legacy explicit class overrides if present
      document.body.classList.remove('bg-dark', 'text-white');
    });
  }

  /**
   * Universal toggle utility method
   */
  toggleTheme(): void {
    this.isDarkMode.update((current) => !current);
  }
}
